import reducer, { modalsSlice } from './slice';

export const { openModal, closeModal } = modalsSlice.actions;

export default reducer;
